import { combineReducers } from "redux";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { createSlices } from "./slices";
import getMiddlewaresArray from "./middlewares";
import { createTransform, createMigrate } from "redux-persist";
import { migrations } from "./migrations";
import { persistStore, persistReducer } from "redux-persist";
import { slicesArray } from "./defaultStoreData";
import omit from "lodash/omit";
import initSubscriber from "redux-subscriber";
import storage from "redux-persist/lib/storage";
import localforage from "localforage";

const MIGRATION_DEBUG = false;
const ENABLE_PERSIST = true;

const createSlicesReducers = (slices: any, _combineReducers: any) => {
  let slicesReducers: any = {};
  Object.keys(slices).forEach((slice: any) => {
    slicesReducers[slices[slice].name] = slices[slice].reducer;
  });
  return _combineReducers(slicesReducers);
};

const createReducer = (slices: any, _combineReducers: any) => {
  const entitiesReducer = createSlicesReducers(slices, _combineReducers);
  return _combineReducers({
    entities: entitiesReducer,
  });
};
const configureImxStore = ({
  slices,
  reducer,
  _configureStore,
  _persistReducer,
  _persistStore,
  _storage,
  _getDefaultMiddleware,
  _getMiddlewaresArray,
}: any) => {
  const blacklistTransform = createTransform((inboundState: object, key) => {
    if (key === "entities") {
      return omit(inboundState, ["editor", "revision"]);
    } else {
      return { ...inboundState };
    }
  });
  const persistConfig = {
    key: "entities",
    storage: localforage,
    transforms: [blacklistTransform],
    version: 0,
    migrate: createMigrate(migrations, { debug: MIGRATION_DEBUG }),
  };
  const persistedReducer = ENABLE_PERSIST
    ? _persistReducer(persistConfig, reducer)
    : reducer;
  let store = _configureStore({
    reducer: persistedReducer,
    middleware: [
      ..._getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }),
      ..._getMiddlewaresArray(slices),
    ],
  });

  let persistor = ENABLE_PERSIST ? _persistStore(store) : null;
  initSubscriber(store);

  return { persistor, store };
};

const createStore = () => {
  const appsSlices = createSlices(slicesArray);
  const reducer = createReducer(appsSlices, combineReducers);
  const slices = appsSlices;
  const storeConfig = {
    slicesArray: slicesArray,
    slices,
    reducer: reducer,
    _configureStore: configureStore,
    _persistStore: persistStore,
    _storage: storage,
    _persistReducer: persistReducer,
    _getDefaultMiddleware: getDefaultMiddleware,
    _getMiddlewaresArray: getMiddlewaresArray,
  };
  const { store, persistor } = configureImxStore(storeConfig);
  store.slices = slices;
  store.persistor = persistor;

  return { slices, store, persistor };
};

export const defaultStore = createStore();
